// extracted by mini-css-extract-plugin
export default {"Title":"LawCell_Title__yhpYZ","Name":"LawCell_Name__nLA4r","Expired":"LawCell_Expired__hzwrW","WarnSpan":"LawCell_WarnSpan__GjrD3"};